var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_029a44da"]},_vm.$listeners),[_c('cube-float-ball',{attrs:{"name":"default","initialPosition":(_vm.defaultPos)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }